'use client';
import { useState, useEffect } from 'react';
import SpAttributeOption from '@/app/_components/singleProduct/SpAttributeOption';
import { useProductContext } from '@/app/_providers/ProductContext';
import { useSearchParams } from 'next/navigation';

export default function SpAttributes({ variations, productType }) {
  const [attributes, setAttributes] = useState([]);
  const [options, setOptions] = useState([]);
  const [matches, setMatches] = useState([]);
  const [filters, setFilters] = useState([]);
  const { currentVariation, setCurrentVariation } = useProductContext();
  const searchParams = useSearchParams();

  // Initialize current variation based on stock availability
  useEffect(() => {
    if (variations?.length > 0) {
      const pCode = searchParams.get('pCode');
      let selectedVariation;
      if (pCode) {
        selectedVariation = variations.find(
          (variation) => variation.id == pCode
        );
      }

      if (!selectedVariation) {
        selectedVariation =
          variations.find((variation) => variation.stock > 0) || variations[0];
      }

      setCurrentVariation(selectedVariation);
      initializeAttributesAndFilters(selectedVariation);
    }
  }, [variations, searchParams]);

  // find variation with filter and update variation matches
  useEffect(() => {
    if (variations?.length > 0) {
      findVariationWithFilters();
      updateVariationMatches();
    }
  }, [filters, attributes, variations]);

  const initializeAttributesAndFilters = (variation) => {
    get_attributes(variation);
    setFilters(
      variation.attributes.map((attr) => ({
        key: attr.name,
        value: attr.value,
      }))
    );
  };

  const onVariationChange = (key, value) => {
    const newFilter = { key, value };
    const matchesVariation = variations.some((variation) =>
      [...filters.filter((filter) => filter.key !== key), newFilter].every(
        (filter) =>
          variation.attributes.some(
            (attr) => attr.name === filter.key && attr.value === filter.value
          )
      )
    );

    if (matchesVariation) {
      const updatedFilters = filters.filter((filter) => filter.key !== key);
      if (key === attributes[0]) {
        updatedFilters.push(newFilter);
        const secondAttribute = attributes[1];
        const firstOptionForSecondAttribute =
          options[secondAttribute] && options[secondAttribute][0];

        if (firstOptionForSecondAttribute) {
          const secondAttributeFilter = {
            key: secondAttribute,
            value: firstOptionForSecondAttribute,
          };
          updatedFilters.push(secondAttributeFilter);
        }
      } else if (key === attributes[1]) {
        if (matchesVariation) {
          updatedFilters.push(newFilter);
        }
      } else {
        updatedFilters.push(newFilter);
      }

      setFilters(updatedFilters);
    } else {
      setFilters([newFilter]);
    }
  };

  // find option that matches with filter in variable product
  const updateVariationMatches = () => {
    const newMatches = [];
    filters.map((filter) => {
      variations.map((price) => {
        price.attributes.map((attr) => {
          if (attr.name === filter.key && attr.value === filter.value) {
            price.attributes.map((vattribute) => {
              newMatches.push(vattribute.value);
            });
          }
        });
      });
    });

    setMatches(newMatches);
  };

  // Load all attributes of variable product
  const get_attributes = (initialVariation) => {
    setAttributes([]);
    const newAttributes = [];
    const newOptions = [];
    let newFilters = [];

    if (productType === 'variable') {
      variations.map((price, index) => {
        price.attributes.map((variation_attribute) => {
          const attr = newAttributes.find(
            (attribute) => variation_attribute.name === attribute
          );

          if (!attr) {
            newAttributes.push(variation_attribute.name);

            if (price === initialVariation) {
              newFilters.push({
                key: variation_attribute.name,
                value: variation_attribute.value,
              });
            }
          }

          const options = newOptions.find(
            (option) =>
              option.key === variation_attribute.name &&
              option.value === variation_attribute.value
          );

          if (!options) {
            newOptions.push({
              key: variation_attribute.name,
              value: variation_attribute.value,
            });
          }
        });
      });

      setFilters(newFilters);
      setAttributes(newAttributes);
      setOptions(newOptions);
    }
  };

  // find variation that matches with filter in variable product
  const findVariationWithFilters = () => {
    if (filters.length === attributes.length && variations.length > 1) {
      const ProductVars = variations.filter(
        (price) =>
          price.attributes.filter(
            (attribute) =>
              filters.filter(
                (filter) =>
                  attribute.name === filter.key &&
                  attribute.value === filter.value
              ).length >= 1
          ).length >= filters.length
      );
      if (ProductVars.length > 0) {
        setCurrentVariation({ ...ProductVars[0] });
      }
    }
  };

  return (
    <>
      {attributes.map((attr, index) => (
        <SpAttributeOption
          key={index}
          attr={attr}
          attrIndex={index}
          options={options}
          filters={filters}
          matches={matches}
          onVariationChange={onVariationChange}
        />
      ))}
    </>
  );
}
